import React  from "react";
import View   from "./view";
import MaskedInput from "react-text-mask";
import Checkbox from "material-ui/Checkbox";

import "./form.css";
import config from "../../../config";

export default class ContactsView extends View {
    static get title () {
        return "укажите персональные данные";
    }

    static get titleShort() {
        return "персональные данные";
    }

    static get defaultProps() {
        return {
            clinic: React.PropTypes.number.isRequired,
            doctor: React.PropTypes.number.isRequired,
            date: React.PropTypes.string.isRequired,
            time: React.PropTypes.string.isRequired,
        };
    }

    static get contextTypes() {
        return {
            muiTheme: React.PropTypes.object,
        };
    }

    constructor(props) {
        super(props);

        this.state = {
            agree: false,
            lastname: "",
            firstname: "",
            middlename: "",
            birthDate: "",
            phone: "",
            email: "",

            errorsVisibility: {
                "lastname": false,
                "firstname": false,
                "middlename": false,
                "birthDate": false,
                "phone": false,
                "email": false,
            },

            errors: {
                "lastname": "",
                "firstname": "",
                "middlename": "",
                "birthDate": "",
                "phone": "",
                "email": "",
            }
        };

        this.lastnameInputReference = null;
        console.log('contacts-props',props)
    }
    getPrivateUrl(){
        let url = config.privateUrl
            const urlTag = document.getElementById('medangel-private')
        if (!!urlTag) {
            url=urlTag.getAttribute('data-url')
        }
        return url
    }

    pad (num, size) {
        let s = num + "";
        while (s.length < size) s = "0" + s;
        return s;
    }

    validateForm() {
        const errorsVisibility = {};
        const errors = {};
        let isError = false;
        for (const propertyName in this.state.errorsVisibility) {
            if (this.state[propertyName].trim().length > 0) {
                errorsVisibility[propertyName] = false;
            } else {
                isError = true;
                errorsVisibility[propertyName] = true;
                errors[propertyName] = "Это поле обязательно для заполнения.";
            }
        }

        let validBirthDate = null;
        try {
            const dateSplited = this.state.birthDate.split(".");
            validBirthDate = new Date(
                parseInt(dateSplited[2], 10),
                parseInt(dateSplited[1], 10) - 1,
                parseInt(dateSplited[0], 10)
            );

            if (Number.isNaN(validBirthDate.getTime())) {
                throw new Error("Invalid Date: NaN.");
            }

            const today = new Date();
            const minimalDate = new Date(1900, 1, 1);
            if (validBirthDate <= minimalDate || validBirthDate > today) {
                throw new Error("Date out of range.");
            }

        } catch (error) {
            isError = true;
            errorsVisibility["birthDate"] = true;
            errors["birthDate"] = "Указана неверная дата рождения.";
        }

        this.setState({
            errorsVisibility,
            errors
        });

        if (isError === true) {
            return;
        }
        this.props.setBookingIsDone(true);
        function findGetParameter(parameterName) {
            var result = null,
                tmp = [];
            location.search
                .substr(1)
                .split("&")
                .forEach(function (item) {
                    tmp = item.split("=");
                    if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
                });
            return result;
        }
        const utm_source = findGetParameter("utm_source");
        this.props.gotoNextView({
            breadcrumbName: "ввод персональных данных",
            nextView: "BookingView",
            props: {
                lastname: this.state.lastname,
                firstname: this.state.firstname,
                middlename: this.state.middlename,
                birthDate: `${validBirthDate.getFullYear()}-` +
                           `${this.pad(validBirthDate.getMonth()+1, 2)}-` +
                           `${this.pad(validBirthDate.getDate(), 2)}`,
                phone: this.state.phone,
                email: this.state.email,

                clinic:     this.props.clinic,
                doctor:     this.props.doctor,
                service:    this.props.service,
                date:       this.props.date,
                time:       this.props.time,
                utm_source:       utm_source,
            }
        });
    }

    handleButtonClick() {
        this.validateForm();
    }

    renderErrorMessage(propertyName) {
        if (this.state.errorsVisibility[propertyName]) {
            return <div className="appointment-form__error">{this.state.errors[propertyName]}</div>;
        } else {
            return null;
        }
    }

    handleKeyPress(event) {
        if (event.key === "Enter") {
            this.validateForm();
        }
    }

    componentDidMount() {
        if (this.lastnameInputReference !== null) {
            this.lastnameInputReference.focus();
        }
    }

    render() {
        const colors = this.context.muiTheme.palette;
        return (
            <div className="appointment-view appointment-view--contacts">
                <form className="appointment-form">
                    <div className="appointment-form__element">
                        <label className="appointment-form__label"> Фамилия </label>

                        <input
                            style={{
                                backgroundColor: colors.primary3color
                            }}

                            value={this.state.lastname}
                            ref={(reference) => { this.lastnameInputReference = reference; }}
                            onKeyPress={(event) => this.handleKeyPress(event)}
                            onChange={(event) => this.setState({ lastname: event.target.value })}
                            className="appointment-text-field" type="text" />

                        {this.renderErrorMessage("lastname")}
                    </div>

                    <div className="appointment-form__element">
                        <label className="appointment-form__label"> Имя </label>
                        <input
                            style={{
                                backgroundColor: colors.primary3color
                            }}

                            value={this.state.firstname}
                            onKeyPress={(event) => this.handleKeyPress(event)}
                            onChange={(event) => this.setState({ firstname: event.target.value })}
                            className="appointment-text-field" type="text" />

                        {this.renderErrorMessage("firstname")}
                    </div>

                    <div className="appointment-form__element">
                        <label className="appointment-form__label"> Отчество </label>
                        <input
                            style={{
                                backgroundColor: colors.primary3color
                            }}

                            value={this.state.middlename}
                            onKeyPress={(event) => this.handleKeyPress(event)}
                            onChange={(event) => this.setState({ middlename: event.target.value })}
                            className="appointment-text-field" type="text" />

                        {this.renderErrorMessage("middlename")}
                    </div>

                    <div className="appointment-form__element">
                        <label className="appointment-form__label"> Дата рождения </label>
                        <MaskedInput
                            style={{ backgroundColor: colors.primary3color }}
                            mask={[ /\d/,/\d/, ".", /\d/,/\d/, ".", /\d/,/\d/,/\d/,/\d/ ]}
                            value={this.state.birthDate}
                            placeholder={"__.__.____"}
                            onKeyPress={(event) => this.handleKeyPress(event)}
                            onChange={(event) => {
                                this.setState({ birthDate: event.target.value });
                            }}
                            className="appointment-text-field" type="text" />

                        {this.renderErrorMessage("birthDate")}
                    </div>

                    <div className="appointment-form__element">
                        <label className="appointment-form__label"> Номер телефона </label>
                        <MaskedInput
                            style={{
                                backgroundColor: colors.primary3color
                            }}

                            mask={["+", "7", "(", /\d/, /\d/, /\d/, ")", /\d/, /\d/, /\d/, "-", /\d/, /\d/, "-", /\d/, /\d/]}
                            required="true"
                            value={this.state.phone}
                            placeholder={"+7(___)___-__-__"}
                            onKeyPress={(value) => this.handleKeyPress(value)}
                            onChange={(event) => this.setState({ phone: event.target.value })}
                            className="appointment-text-field" type="text" />

                        {this.renderErrorMessage("phone")}
                    </div>
                    <div className="appointment-form__element">
                        <label className="appointment-form__label"> EMAIL <i>(Вам будет выслано письмо с кодом подтверждения брони)</i> </label>

                        <input
                            style={{
                                backgroundColor: colors.primary3color
                            }}

                            value={this.state.email}
                            onKeyPress={(event) => this.handleKeyPress(event)}
                            onChange={(event) => this.setState({email: event.target.value})}
                            className="appointment-text-field" type="text"/>
                        {this.renderErrorMessage("email")}

                    </div>
                    <div className='appointment-form__next' style={{display:'flex',alignItems: 'center'}}>
                        <div>
                            <Checkbox
                            checked={this.state.agree}
                            style={{display: 'block'}}
                            label=""

                        onCheck={(e) => {
                                this.setState({agree: !this.state.agree})
                            }}/>
                        </div>
                        <p className=''>Согласен с обработкой персональных данных в соответствии с <a style={{
                            color: colors.accent5color
                        }} target="_blank" href={this.getPrivateUrl()}>политикой конфиденциальности</a></p>
                    </div>

                    <div className="appointment-form__element">

                        <button
                            style={this.state.agree ?
                                {backgroundColor: colors.accent5color} : {backgroundColor: colors.primary2color}
                            }
                            disabled={!this.state.agree}
                            onKeyPress={(event) => this.handleKeyPress(event)}
                            onClick={() => this.handleButtonClick()}
                            type="button"
                            className="appointment-form__button">
                            продолжить
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/views/contacts.js
 **/